// AwaitingUsBadge — the single most useful flag on this page (spec §4 / §5 rule 7).
//
// awaiting_us means the last message was inbound — they are waiting on you. It is
// the ONLY unread badge on the Conversations page: a channel with 400 unread
// messages is not 400 problems, but a thread where the client is waiting is one
// problem. Show it prominently, only on threads, never on a channel or DM.
//
// Rendered inside <ThreadRow>. Kept its own file so the "only awaiting_us gets a
// count" rule has one home — if you are adding an unread badge anywhere else, stop.
import React from "react";

/**
 * @param {object} props
 * @param {number} [props.count]   Messages waiting (the thread's inbound-since-last-outbound).
 *                                  When absent, renders a dot (not a count) — the flag itself is the signal.
 * @param {string} [props.className]
 */
export default function AwaitingUsBadge({ count, className = "" }) {
  return (
    <span
      data-testid="awaiting-us-badge"
      className={`inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-700 dark:bg-amber-900/30 dark:text-amber-300 ${className}`}
      aria-label="Waiting on you"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-amber-500" aria-hidden="true" />
      {typeof count === "number" && count > 0 ? `${count} waiting` : "Waiting"}
    </span>
  );
}
